import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ArrowSwitch({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ArrowSwitch</title>
      <path
        d="M14.0713 11.0713L14.0713 4.00022M14.0713 4.00022L10.5358 7.53575M14.0713 4.00022L17.6068 7.53576"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5356 13.8281V20.8992M10.5356 20.8992L14.0712 17.3637M10.5356 20.8992L7.00011 17.3637"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
